import styled, { css } from 'styled-components';

import { theme } from '../../../common/ui/theme';
import { TableBuilderProps } from '../TableBuilder';

export const StyledTable = styled.table<Pick<TableBuilderProps<unknown>, 'variant'>>`
    border: ${(props) => (props.variant === 'default' ? '1px' : 0)} solid ${theme.colors.background.inset};
    width: 100%;

    ${(props) =>
        props.variant === 'inline'
            ? css`
                  border-collapse: separate;
                  border-spacing: 0 ${theme.space[4]};
              `
            : null}
`;
